import { useState } from 'react';
import { FaGithub, FaLinkedin, FaDownload } from 'react-icons/fa';
import { IoMdMail } from 'react-icons/io';
import { HiArrowDown } from 'react-icons/hi';
import HeroImg from '../assets/PROFILEIMGE.jpg';
import resume from '../assets/ATCHAYA_Software_developer.pdf';
import { useTypewriter, Cursor } from 'react-simple-typewriter';

export default function Hero() {
  const [copied, setCopied] = useState(false);

  const handleEmailClick = (e) => {
    navigator.clipboard.writeText('atchayakannan03@gmail.com');
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const [text] = useTypewriter({
    words: [
      'Full Stack Developer',
      'React.js & React Native Developer',
      'Frontend Developer',
      '.NET & SQL Server Developer',
      'Immediate Joiner',
    ],
    loop: {},
    typeSpeed: 70,
    deleteSpeed: 50,
  });

  return (
    <section id="hero" className="relative min-h-screen flex items-center overflow-hidden pt-16">
      <div className="glow-orb w-72 h-72 md:w-96 md:h-96 bg-violet-600 top-10 -left-20" />
      <div className="glow-orb w-60 h-60 md:w-80 md:h-80 bg-cyan-500 bottom-20 right-0" />

      <div
        className="absolute inset-0 opacity-[0.03]"
        style={{
          backgroundImage:
            'linear-gradient(rgba(255,255,255,0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.1) 1px, transparent 1px)',
          backgroundSize: '50px 50px',
        }}
      />

      <div className="max-w-6xl mx-auto px-4 sm:px-6 w-full py-16 relative z-10">
        <div className="flex flex-col items-center text-center md:flex-row md:text-left gap-10 md:gap-12">

          {/* Image — top on mobile */}
          <div className="flex-shrink-0 order-1 md:order-2">
            <div className="relative">
              <div
                className="absolute -inset-3 rounded-full animate-spin-slow opacity-30"
                style={{ background: 'conic-gradient(from 0deg, #7c3aed, #06b6d4, #7c3aed)' }}
              />
              <div
                className="relative w-48 h-48 sm:w-56 sm:h-56 md:w-72 md:h-72 rounded-full overflow-hidden animate-float animate-pulse-glow"
                style={{ border: '3px solid rgba(124,58,237,0.5)' }}
              >
                <img src={HeroImg} alt="Atchaya" className="w-full h-full object-cover object-top" />
              </div>
              <div
                className="absolute -bottom-3 -left-6 px-3 py-1.5 rounded-xl text-xs font-semibold text-white"
                style={{ background: 'linear-gradient(135deg,#7c3aed,#06b6d4)', boxShadow: '0 8px 20px rgba(124,58,237,0.4)' }}
              >
                2 Years Experience
              </div>
              <div
                className="absolute -top-3 -right-4 px-3 py-1.5 rounded-xl text-xs font-semibold text-white"
                style={{ background: 'linear-gradient(135deg,#06b6d4,#7c3aed)', boxShadow: '0 8px 20px rgba(6,182,212,0.4)' }}
              >
                5+ Projects
              </div>
            </div>
          </div>

          {/* Text */}
          <div className="flex-1 order-2 md:order-1">
            <div
              className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs sm:text-sm font-medium mb-5"
              style={{ background: 'rgba(124,58,237,0.15)', border: '1px solid rgba(124,58,237,0.3)', color: '#a78bfa' }}
            >
              <span className="w-2 h-2 rounded-full bg-green-400 animate-pulse flex-shrink-0" />
              Immediate Joiner · Chennai | On-site, Hybrid or Remote
            </div>

            <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold leading-tight mb-3">
              Hi, I'm <span className="gradient-text">Atchaya</span>
            </h1>

            <h2 className="text-lg sm:text-2xl md:text-3xl font-semibold text-slate-300 mb-5 min-h-[2.5rem]">
              <span className="text-violet-400">{text}</span>
              <Cursor cursorColor="#7c3aed" />
            </h2>

            <p className="text-slate-400 text-sm sm:text-base leading-relaxed mb-7 max-w-xl mx-auto md:mx-0">
              Full Stack Developer with 2 years of experience building scalable web & mobile apps.
              Shipped 5+ production apps used by 200+ end users across ERP, HRMS, and Safety domains.
            </p>

            <div className="flex flex-wrap justify-center md:justify-start gap-3 mb-8">
              <a href={resume} download="Atchaya_Resume" className="btn-primary text-sm">
                <FaDownload size={13} /> Download Resume
              </a>
              <a href="#projects" className="btn-outline text-sm" style={{ cursor: 'pointer' }}>
                View My Work
              </a>
            </div>

            <div className="flex items-center justify-center md:justify-start gap-4">
              <span className="text-slate-500 text-sm">Find me on</span>
              <div className="flex gap-3">
                {[
                  { icon: <FaLinkedin size={18} />, href: 'https://www.linkedin.com/in/atchaya-k-713424211/', label: 'LinkedIn' },
                  { icon: <FaGithub size={18} />, href: 'https://github.com/atchu33', label: 'GitHub' },
                  { icon: <IoMdMail size={18} />, href: 'mailto:atchayakannan03@gmail.com', label: 'Email', isEmail: true },
                ].map(s => (
                  <a
                    key={s.label}
                    href={s.href}
                    aria-label={s.label}
                    onClick={s.isEmail ? handleEmailClick : undefined}
                    className="w-9 h-9 rounded-xl flex items-center justify-center text-slate-400 hover:text-violet-400 transition-all duration-300 hover:-translate-y-1"
                    style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)' }}
                  >
                    {s.icon}
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="flex justify-center mt-12 animate-bounce">
          <a href="#about" aria-label="Scroll down" className="text-slate-500 hover:text-violet-400 transition-colors">
            <HiArrowDown size={22} />
          </a>
        </div>
      </div>
      {copied && (
        <div className="fixed bottom-5 right-5 bg-slate-900/90 text-violet-400 border border-violet-500/30 px-4 py-2.5 rounded-xl shadow-xl backdrop-blur-sm text-sm font-semibold z-50 flex items-center gap-2" style={{ animation: 'bounce 1s infinite' }}>
          <span>📧 Email copied to clipboard!</span>
        </div>
      )}
    </section>
  );
}
